import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconFilterDefault({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.488 2c.827 0 1.496.672 1.496 1.5v1.031L9.62 3.156a1.494 1.494 0 0 1 2.108.186L13.65 5.64c.531.634.448 1.58-.184 2.113L7.188 13.03A2.977 2.977 0 0 1 4.992 14 2.996 2.996 0 0 1 2 11V3.5C2 2.672 2.67 2 3.496 2h2.992zM3.496 3a.5.5 0 0 0-.499.5V11c0 1.104.894 2 1.995 2a1.998 1.998 0 0 0 1.995-2V3.5a.5.5 0 0 0-.499-.5H3.496zm1.496 7a1 1 0 0 1 0 2 .999.999 0 0 1-.997-1c0-.552.446-1 .997-1zm5.97-6.016a.499.499 0 0 0-.702-.061L7.984 5.837V11l-.002.059 4.842-4.073a.5.5 0 0 0 .062-.704l-1.923-2.298z" fill={fill}/>
        </svg>

    );
}

export default IconFilterDefault;
